// extracted by mini-css-extract-plugin
export default {"tipsMask":"index_tipsMask_sHeLw","textCenter":"index_textCenter_qV5D-","tipsText":"index_tipsText_boxWh","openClient":"index_openClient_WsxF4"};